import * as actionType from "../actions/actionType";
import { cloneDeep } from "lodash";

const initialState = {
  rpaTaskId: 0,
  talentTier: "",
  nickname: "",
  contactStatus: 0,
  dataSource: 1,
  serialNumber: "",
  creatorContentCategory:'',
  productCategory:'',
  

  tableList: [],
  loading: false,
  pageNum: 1,
  pageSize: 10,
  tableListTotal: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.APPARATUS_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };

    default:
      return state;
  }
};
